import { useEffect, useRef } from 'react';
import { useOfflineStatus } from 'services/OfflineStatusContext';
import { syncService } from '../offline_items/syncService';
import { showConflictToast } from './ConflictToast';

const ConflictHandler = () => {
  const { conflictDetected, conflictItemId, conflictItemName } = useOfflineStatus();
  const shownConflicts = useRef(new Set());

  useEffect(() => {
    if (conflictDetected && conflictItemId && !shownConflicts.current.has(conflictItemId)) {
      shownConflicts.current.add(conflictItemId);
      
      const handleResolve = async (strategy) => {
        try {
          await syncService.resolveConflictWithStrategy(conflictItemId, strategy);
          shownConflicts.current.delete(conflictItemId);
        } catch (error) {
          console.error('Failed to resolve conflict:', error);
        }
      };

      showConflictToast(conflictItemName || 'Unknown Item', conflictItemId, handleResolve);
    }
  }, [conflictDetected, conflictItemId, conflictItemName]);

  return null;
};

export default ConflictHandler;
